import { apiFetch } from './api.js';
import { updateUIForLoggedInState, updateUIForLoggedOutState } from './ui.js';

export function checkSession() {
  apiFetch("/api/v1/session", { cache: "no-store" })
    .then(user => user ? updateUIForLoggedInState(user) : updateUIForLoggedOutState())
    .catch(() => updateUIForLoggedOutState());
}
